import React, { useState } from "react";
import { Button } from "./ui/button";
import { Download, Loader2 } from "lucide-react";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Botão de exportação Excel. Envia os filtros atuais ao backend e baixa .xlsx.
 *
 * @param {string} endpoint  Ex: "/export/clientes"
 * @param {object} filtros   Filtros atuais ({ q, status, etc. })
 * @param {string} nomeArquivo Ex: "clientes" (sufixo de data será adicionado)
 */
export function ExportarBotao({ endpoint, filtros = {}, nomeArquivo = "export", testId = "btn-exportar" }) {
  const [busy, setBusy] = useState(false);

  const exportar = async () => {
    setBusy(true);
    try {
      const token = localStorage.getItem("lab_token") || "";
      const params = new URLSearchParams(
        Object.fromEntries(
          Object.entries(filtros).filter(([, v]) => v !== "" && v != null && v !== "all")
        )
      );
      const url = `${BACKEND_URL}/api${endpoint}?${params.toString()}`;
      const resp = await fetch(url, {
        method: "GET",
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!resp.ok) {
        const txt = await resp.text();
        let msg = `Erro ${resp.status}`;
        try { msg = JSON.parse(txt).detail || msg; } catch {}
        toast.error(msg);
        return;
      }
      const blob = await resp.blob();
      const a = document.createElement("a");
      const ts = new Date().toISOString().slice(0, 10);
      a.href = URL.createObjectURL(blob);
      a.download = `${nomeArquivo}_${ts}.xlsx`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(a.href);
      toast.success("Arquivo baixado");
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error("[Export]", err);
      toast.error("Falha ao exportar");
    } finally {
      setBusy(false);
    }
  };

  return (
    <Button
      onClick={exportar}
      disabled={busy}
      variant="outline"
      size="sm"
      data-testid={testId}
      className="h-9"
    >
      {busy ? <Loader2 className="w-3.5 h-3.5 mr-1 animate-spin" /> : <Download className="w-3.5 h-3.5 mr-1" />}
      Exportar Excel
    </Button>
  );
}
